import React from 'react';
import { ToolbarSearch } from '../toolbar';

interface Props {
  customerFilter: string;
  productFilter: string;
  onCustomerFilterChange: (v: string) => void;
  onProductFilterChange: (v: string) => void;
  /** Hide the Customer field on tabs with no customer dimension (e.g. Mappings). */
  hideCustomer?: boolean;
}

/**
 * The shared Customer / Product free-text filters, rendered inline within a
 * tab's own toolbar (next to its dropdowns). State lives on ReconciliationPage
 * so both values persist as the operator switches tabs; each tab applies them
 * to whichever customer/product fields its rows carry.
 */
export const ReconciliationFilterFields: React.FC<Props> = ({
  customerFilter,
  productFilter,
  onCustomerFilterChange,
  onProductFilterChange,
  hideCustomer = false,
}) => (
  <>
    {!hideCustomer && (
      <ToolbarSearch
        searchValue={customerFilter}
        onSearchChange={onCustomerFilterChange}
        searchPlaceholder="Filter customer…"
        maxWidth={220}
      />
    )}
    <ToolbarSearch
      searchValue={productFilter}
      onSearchChange={onProductFilterChange}
      searchPlaceholder="Filter product…"
      maxWidth={220}
    />
  </>
);
